import { PageFiltersType } from "@/pages/dashboard/types/dashboard";

import { OptionDataType } from "./../_types";

export const formatOptionsData = (
  pageSelector: PageFiltersType[],
  realPath: string,
  locale: string,
  SEPARATED_OPTIONS: any
): OptionDataType[] => {
  const isEn = locale === 'en-US';

  const optionsData: OptionDataType[] = [
    {
      groupKey: 'accumulated',
      value: 'accumulated',
      text: isEn ? "Accumulated" : "累计值",
    },
  ];

  // let dataItem: PageFiltersType['filters'] = [];

  // pageSelector
  //   .filter((item: PageFiltersType) => {
  //     const { path } = item;
  //     // Path wildcard
  //     return (`/${  realPath}`).toLowerCase().startsWith(path.replace('*', '').toLowerCase());
  //   })
  //   .forEach((item: PageFiltersType) => {
  //     dataItem = item?.filters || [];
  //   });

  // const separatedOptions = dataItem.flatMap((item) => {
  //   const baseOption = {
  //     groupKey: 'separated',
  //     value: item.key,
  //     text: isEn ? `By ${item.name_en}` : `分${item.name_cn}`,
  //   };

  //   if (item.key === 'region') {
  //     return [
  //       baseOption,
  //       {
  //         groupKey: 'separated',
  //         value: 'country',
  //         text: isEn ? 'By Country' : '分国家',
  //       },
  //     ];
  //   }

  //   return [baseOption];
  // });

  if (SEPARATED_OPTIONS.length > 0) {
    return [...optionsData, ...SEPARATED_OPTIONS];
  } 
  return [];
  
};